<ng-content selector="td[prizmTd]"></ng-content>
<ng-container *ngIf="cells$ | async as cells">
  <ng-container *ngFor="let cell of cells">
    <ng-container *ngIf="cell?.template" [ngTemplateOutlet]="$any(cell?.template)"></ng-container>
  </ng-container>
</ng-container>
